module.exports = __webpack_public_path__ + "static/media/drone.f8d2dd2e.mp4";